import * as React from "react"
import { cva } from "class-variance-authority"
import { cn } from "../../lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors uppercase tracking-wide",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
        paid: "bg-[#DCFCE7] text-[#15803D]",
        sent: "bg-[#DBEAFE] text-[#1D4ED8]",
        approved: "bg-[#FEF3C7] text-[#B45309]",
         deleted: "bg-red-200/50 text-red-500",
        draft: "bg-[#F3F4F6] text-[#4B5563]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({ className, variant, ...props }) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
